import { getInitialPropertyValue } from 'automation-ui-references/transform/transformEngagement';
export const TASK_ACTION_DEFAULT_DAYS = 0;
export const TASK_ACTION_DEFAULT_MINUTES = 8 * 60;
export const TASK_ACTION_TYPE = getInitialPropertyValue('engagement.type');